{
  "kk": {
    "citiesMismatch": {
      "alternativeCity": "{offered} әуежайы {original} қаласынан {distance} км қашық жатыр"
    },
    "duration": "{duration} жол",
    "flight": "Рейс {airline}{number}",
    "train": "Пойыз",
    "expressTrain": "Жылдам пойыз",
    "trainNumber": "Пойыз №{number}",
    "railSegment": "Т/Ж сегменті",
    "railTransfer": "Т/Ж ауысып отыру",
    "railTransferCity": "{city} қаласындағы пойызға ауысып отыру",
    "railTransferTime": "Ауысып отыру уақыты: ~{duration}",
    "railTransferDescription": "Маршруттың келесі бөлігі {trainName} пойызымен жүзеге асырылады. Сізге {stationName} вокзалына жетуіңіз қажет.",
    "terminal": "Терминал {terminal}",
    "baggage": "Багаж: {baggage}",
    "handLuggage": "Қолжүк: {handLuggage}",
    "handLuggageMissing": "Қол жүгі жоқ",
    "baggageMissing": "Жүксіз",
    "warnings": {
      "distinctBookings": "Әртүрлі бронь болып рәсімделетін билет",
      "refundExchangeRules": "Броньдардың ауыстыру және қайтару ережелері әртүрлі",
      "differentBaggage": "Әр бағыттың багаж нормасы әртүрлі",
      "baggageSelfTransition": "{city} қ., {cityCode} багажды өзіңіз алып, өзіңіз тапсырасыз",
      "selfTransfer": "Өз бетімен ауысып отыру",
      "differentAirports": "Қону және ұшу әуежайлары әртүрлі",
      "differentTerminals": "Қону және ұшу терминалдары әртүрлі",
      "baggageReCheckIn": "Багажды қайта тіркеу керек",
      "guaranteedTransfer": "Ауысып отыратыныңызға әуе компаниясы кепіл",
      "nextDayDeparture": "Келесі күні ұшасыз",
      "nextDayDepartureRail": "Келесі күні аттанасыз",
      "shortTransfer": "Қысқа ауысып отыру рейсі",
      "improveFare": "Тариф шарттарын (багаж, ауыстыру, қайтару) келесі бетте жақсартуға болады",
      "stopLocation": "Аялдау: {city} {duration}"
    },
    "transferCity": "{city} қ. ауысып отыру",
    "segmentDuration": "{duration} жол",
    "railSegmentDuration": "{duration} жол",
    "newHandLuggage": "Қол жүгі: {n} кг",
    "increasedBy": "+2 кг"
  },
  "ru": {
    "citiesMismatch": {
      "alternativeCity": "Аэропорт г. {offered} находится в {distance} км от г. {original}"
    },
    "duration": "{duration} в пути",
    "flight": "Рейс {airline}{number}",
    "train": "Поезд",
    "expressTrain": "Скоростной поезд",
    "trainNumber": "Поезд №{number}",
    "railSegment": "Ж/Д сегмент",
    "railTransfer": "ЖД-пересадка",
    "railTransferCity": "Пересадка на поезд в {city}",
    "railTransferTime": "Время на пересадку: ~{duration}",
    "railTransferDescription": "Следующий участок маршрута выполняется на поезде {trainName}. Вам потребуется добраться до вокзала {stationName}.",
    "terminal": "Терминал {terminal}",
    "baggage": "Багаж: {baggage}",
    "handLuggage": "Ручная кладь: {handLuggage}",
    "handLuggageMissing": "Без ручной клади",
    "baggageMissing": "Без багажа",
    "warnings": {
      "distinctBookings": "Билет будет выписан разными бронями",
      "refundExchangeRules": "Правила обмена и возврата у каждой брони свои",
      "differentBaggage": "Разный багаж на направлениях",
      "baggageSelfTransition": "Самостоятельное перемещение багажа в {city}, {cityCode}",
      "selfTransfer": "Самостоятельная пересадка",
      "differentAirports": "Разные аэропорты прилета и вылета",
      "differentTerminals": "Разные терминалы прилета и вылета",
      "baggageReCheckIn": "Необходимо повторно зарегистрировать багаж",
      "guaranteedTransfer": "Пересадка гарантирована авиакомпанией",
      "nextDayDeparture": "Вылет на следующий день",
      "nextDayDepartureRail": "Выезд на следующий день",
      "shortTransfer": "Короткая пересадка",
      "improveFare": "Условия тарифа (багаж, обмен, возврат) возможно улучшить на следующем шаге",
      "stopLocation": "Остановка в г. {city} {duration}"
    },
    "transferCity": "Пересадка в г.{city}",
    "segmentDuration": "{duration} в полете",
    "railSegmentDuration": "{duration} в пути",
    "newHandLuggage": "Ручная кладь: теперь {n} кг",
    "increasedBy": "+2 кг"
  },
  "en": {
    "citiesMismatch": {
      "alternativeCity": "Airport of city {offered} is located {distance} km from city {original}"
    },
    "duration": "{duration} in flight",
    "flight": "Flight {airline}{number}",
    "train": "Train",
    "expressTrain": "Express train",
    "trainNumber": "Train No. {number}",
    "railSegment": "Rail segment",
    "railTransfer": "Rail transfer",
    "railTransferCity": "Train transfer in {city}",
    "railTransferTime": "Transfer time: ~{duration}",
    "railTransferDescription": "The next part of the journey is operated by the {trainName} train. You will need to get to {stationName} station.",
    "terminal": "Terminal {terminal}",
    "baggage": "Baggage: {baggage}",
    "handLuggage": "Hand luggage: {handLuggage}",
    "handLuggageMissing": "No hand luggage",
    "baggageMissing": "No baggage",
    "warnings": {
      "distinctBookings": "Ticket will be issued by different bookings",
      "refundExchangeRules": "Rules for exchange and refund are different for each booking",
      "differentBaggage": "Different baggage allowances for each direction",
      "baggageSelfTransition": "Self-transfer of baggage in {city}, {cityCode}",
      "selfTransfer": "Self-transfer",
      "differentAirports": "Different airports for arrival and departure",
      "differentTerminals": "Different terminals for arrival and departure",
      "baggageReCheckIn": "Baggage needs to be re-checked",
      "guaranteedTransfer": "Guaranteed transfer by the airline",
      "nextDayDeparture": "Departure on the next day",
      "nextDayDepartureRail": "Train departure on the next day",
      "shortTransfer": "Short transfer",
      "improveFare": "Fare conditions (baggage, exchange, refund) can be improved on the next step",
      "stopLocation": "Stop in {city} {duration}"
    },
    "transferCity": "Transfer to {city}",
    "segmentDuration": "{duration} in flight",
    "railSegmentDuration": "{duration} on the train",
    "newHandLuggage": "Hand luggage: now {n} kg",
    "increasedBy": "+2 kg"
  }
}
